import { render, staticRenderFns } from "./AddNewRequest.vue?vue&type=template&id=2066b2f2&scoped=true&"
import script from "./AddNewRequest.vue?vue&type=script&lang=ts&"
export * from "./AddNewRequest.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewRequest.vue?vue&type=style&index=0&id=2066b2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066b2f2",
  null
  
)

export default component.exports